import * as React from "react";
const IconEdit = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.9865 11.9924V17.9924C22.9865 20.2016 21.1956 21.9924 18.9865 21.9924H6.98645C4.77731 21.9924 2.98645 20.2016 2.98645 17.9924V5.99243C2.98645 3.78329 4.77731 1.99243 6.98645 1.99243H12.9865M16.6728 4.01518C16.6728 4.01518 16.6728 5.44548 18.1031 6.87577C19.5334 8.30607 20.9637 8.30607 20.9637 8.30607M10.1411 15.982L13.1447 15.5529C13.578 15.491 13.9795 15.2903 14.289 14.9808L22.394 6.87577C23.1839 6.08584 23.1839 4.80511 22.394 4.01518L20.9637 2.58488C20.1738 1.79495 18.893 1.79495 18.1031 2.58488L9.99809 10.6899C9.68862 10.9994 9.48787 11.4009 9.42597 11.8341L8.99689 14.8378C8.90153 15.5052 9.47365 16.0773 10.1411 15.982Z"
      stroke="#1C1C2C"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconEdit;
